// Copyright (c) 2016 Deere & Company

import './pip-product-details.scss';
import React, {PropTypes} from 'react';
import LabeledLink from '../../../../product/shared/components/labeled-link';
import LabeledString from '../../../../shared/components/labeled-string';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDealer} from '../../../../shared/services/build-dealer';

const PipProductDetails = (props, context) =>
    <div className='pip-product-details'>
        <section className='pip-product-info'>
            <LabeledLink
                data={props.pipProduct.pin}
                href={`#/products/${props.pipProduct.pin}`}
                label='PIN'
            />
            <LabeledString
                data={buildDealer(props.pipProduct.leadAccount, context.user.settings.dealer.displayFormat.key)}
                label='LEAD_DEALER'
            />
            <LabeledString
                data={buildDealer(props.pipProduct.responsibleAccount, context.user.settings.dealer.displayFormat.key)}
                label='RESPONSIBLE_DEALER'
            />
        </section>
    </div>;

PipProductDetails.displayName = 'PipProductDetails';
PipProductDetails.propTypes = {
    pipProduct: PropTypes.instanceOf(PipProduct).isRequired
};
PipProductDetails.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default PipProductDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/pip-product-details/pip-product-details.js